import React, { FC } from "react";
import { Form } from "react-bootstrap";
import SvgIcon from "app/component/svg-icon/SvgIcon";

interface Props {
  value: string;
  onClick: () => void;
  disabled?: boolean;
  isWidget?: boolean;
  tabIndex: 0 | -1 | undefined;
}

const CustomPropertyDate: FC<Props> = ({
  isWidget = false,
  value,
  onClick,
  disabled = false,
  tabIndex,
}) => {
  return (
    <div className="input-date">
      {isWidget ? (
        <Form.Control
          type="text"
          className={"pointer"}
          value={value}
          onClick={onClick}
          tabIndex={tabIndex}
          disabled={disabled}
        />
      ) : (
        <input
          className="input pointer"
          type="text"
          value={value}
          onClick={onClick}
          readOnly
          tabIndex={tabIndex}
        />
      )}
      <SvgIcon
        className="icon icon-calendar pointer"
        href="#svg_icon_calendar"
      />
    </div>
  );
};

export default CustomPropertyDate;
